import React,{useState,useEffect,Suspense} from 'react'
import './landing.css'
import { 
    Button ,
    Divider ,
    Card,
    Modal,
    Statistic,
    Spin
} from 'antd';


import {DollarCircleTwoTone,InstagramOutlined,GithubOutlined} from '@ant-design/icons'
import {Fade} from 'react-reveal'
import {useDispatch,useSelector} from 'react-redux'
import Footer from './Footer'
const OAuth = React.lazy(()=>import('./oauth'))

 function Landing() {
    const [modalVisible,setModalVisible] = useState(false);
    const auth = useSelector(state=>state.auth)
    const dispatch = useDispatch();
    useEffect(()=>{
       
           
    },[])

    return (
        
        <div id="container">
        <Fade>
            <nav id="top-nav">
                 <span id="logo">OPEN QUIZ</span> 
                 <div id="links">
                    <InstagramOutlined  style={{fontSize:"30px"}}/>
                    <GithubOutlined  style={{fontSize:"30px",marginLeft:"5px"}}/>
                 </div>
            </nav>
        </Fade>
            <Divider/>
            <div id="middle">
                <Fade left>
                    
                <div style={{display:"flex",flexDirection:"column",flexWrap:"wrap",justifyContent:"center",alignItems:"center"}}>
                <DollarCircleTwoTone spin style={{fontSize:"60px"}}/>
                    <span id="logo-middle">
                    
                  OPEN QUIZ</span></div>
                </Fade>
           
                <Fade right>
                    <div id="middle-btn-grp">
                        <h1 style={{color:"#3959a2"}}>Want to Earn Money ?</h1>
                        <p>Have you ever thought earning money would be so easy ?<br/>
                            Earn by just winning various QUIZ matches
                        </p>
                        <Button type="primary" shape="round" onClick={()=>setModalVisible(true)}>GET STARTED</Button>
                    
                    </div>
            </Fade>
            
            </div>

            <Divider/>
            <Fade bottom>
            <div id="card-grp">
                
                    <Card title="Earn Real Money" hoverable style={{margin:5}}>
                    Free Website to MAKE MONEY for trying Free apps! Earn real money by 
                    completing simple quiz inside the website. Easily make free money !.
                    </Card>
               
                
                    <Card title="Increase General Knowledge" hoverable style={{margin:5}}>
                    Even in the age of Google, general knowledge still matters. These awesome web-site will help you to 
                    expand your general knowledge from alot of quizzes.
                    </Card>
              
                
                    <Card title="1000+ Quiz Question" hoverable style={{margin:5}}>
                        We have 1000 + trivia based MCQ's questions and True/False Questions as well 
                        which are available in three difficulty.
                    </Card>
             
            </div>
            </Fade>
           <Divider/>
           <div id="stats">
               
                    <Statistic title="Active Users" value={11289} />
                    <Statistic title="Amount Paid to Users" value={12598.54} precision={2} prefix="$"/>
                    
                
            </div>
           <Divider/>
          <Footer/>

           <Modal
           title="Login "
           centered
           visible={modalVisible}
           onOk={() => setModalVisible(false)}
           onCancel={() => setModalVisible(false)}
         >
         <Suspense fallback={<Spin size={40} style={{textAlign:"center"}}/>}>
             <OAuth/>
         </Suspense>
           
         </Modal>
        </div>
    )
}

export default Landing;